import { Badge, Flex, Tooltip } from 'antd'
import { LucideIcon } from 'components/LucideIcon'
import type { FC } from 'react'
import { memo } from 'react'
import styled from 'styled-components'

interface UnresolvedCommentBadgeProps {
  count: number | undefined
}

const RawUnresolvedCommentBadge: FC<UnresolvedCommentBadgeProps> = ({
  count,
}) => {
  if (!count) return null

  return (
    <Tooltip title={`${count} unresolved comment${count > 1 ? 's' : ''}`}>
      <Flex align='center' component='span'>
        <Badge count={count} size='small' offset={[0, 0]}>
          <IconWrapper>
            <LucideIcon name='MessageSquareText' size={13} />
          </IconWrapper>
        </Badge>
      </Flex>
    </Tooltip>
  )
}

export const UnresolvedCommentBadge = memo(RawUnresolvedCommentBadge)

const IconWrapper = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  border-radius: 4px;
  color: ${({ theme }) => theme.forecast.defaultText};
`
